import { EXTERNAL_LINKS } from "../../constants/constants";
import Dashboard from "../../components/icons/Dashboard";
import MeetingRoom from "../../components/icons/MeetingRoom";
import Support from "../../components/icons/Support";

// const navigation1 = [
//   {
//     name: "Dashboard",
//     icon: HomeIcon,
//     current: false,
//     href: "dashboard",
//     open: true,
//     chevron: true,
//     children: [
//       {
//         name: "Weekly Form",
//         href: EXTERNAL_LINKS.WEEKLY_FORM,
//         external: true,
//       },
//       {
//         name: "Sign up for Office Hours",
//         href: EXTERNAL_LINKS.OFFICE_HOURS,
//         external: true,
//       },
//       {
//         name: "Help Center",
//         href: EXTERNAL_LINKS.HELP_CENTER,
//         external: true,
//       },
//       {
//         name: "Contact Support Team",
//         href: EXTERNAL_LINKS.CONTACT_SUPPORT_TEAM,
//         external: true,
//       },
//       { name: "Test Session room", href: "https://student-portal.stepuptutoring.org/student/8OQZX6", external: true },
//       {
//         name: "Training Resources",
//         href: EXTERNAL_LINKS.TRAINING_RESOURCES,
//         external: true,
//       },
//       // {
//       //   name: "Add or Drop a Student",
//       //   href: "https://web.miniextensions.com/28W2UNtj1zrniNjabT4k?prefill_Tutors=2024-t23596",
//       //   external: true,
//       // },
//       {
//         name: "Request a Substitute",
//         href: EXTERNAL_LINKS.REQUEST_SUBSTITUTE,
//         external: true,
//       },
//       {
//         name: "Fill in as a Substitute",
//         href: EXTERNAL_LINKS.FILL_IN_AS_SUBSTITUTE,
//         external: true,
//       },
//       {
//         name: "Angeleno/College Corps Handbook",
//         href: EXTERNAL_LINKS.ANGELENO_HANDBOOK,
//         external: true,
//       },
//       {
//         name: "Report a Bug",
//         href: EXTERNAL_LINKS.REPORT_A_BUG,
//         external: true,
//       },
//     ],
//   },
// ];

const navigation = [
  {
    name: "Dashboard",
    icon: Dashboard,
    open: true,
    chevron: false,
    children: [
      {
        name: "Home",
        href: "/tutoring",
        external: false,
        current: true,
      },
      {
        name: "Updates",
        href: "/",
        external: false,
      },
      {
        name: "Tasks",
        href: "/",
        external: false,
      },
    ],
  },

  {
    name: "Session Management",
    icon: MeetingRoom,
    chevron: true,
    current: false,
    open: true,
    children: [
      {
        name: "Weekly Progress Report",
        href: EXTERNAL_LINKS.WEEKLY_PROGRESS_REPORT,
        external: true,
      },
      {
        name: "Request a Sub",
        href: EXTERNAL_LINKS.REQUEST_SUBSTITUTE,
        external: true,
      },
      {
        name: "Volunteer as a sub",
        href: EXTERNAL_LINKS.VOLUNTEER_TUTOR_APPLICATION,
        external: true,
      },
    ],
  },

  {
    name: "Support & Resources",
    icon: Support,
    chevron: true,
    open: true,
    current: false,
    children: [
      {
        name: "Help Center",
        href: EXTERNAL_LINKS.HELP_CENTER,
        external: true,
      },
      {
        name: "Tutor Handbook",
        href: EXTERNAL_LINKS.TUTOR_HANDBOOK,
        external: true,
      },
      {
        name: "Sign Up for Office Hours",
        href: EXTERNAL_LINKS.OFFICE_HOURS,
        external: true,
      },
      {
        name: "Learning Portal Demo",
        href: EXTERNAL_LINKS.LEARNING_PORTAL_DEMO,
        external: true,
      },
      {
        name: "Request a Feature",
        href: EXTERNAL_LINKS.FEATURE_REQUEST,
        external: true,
      },
      {
        name: "Report a bug",
        href: EXTERNAL_LINKS.REPORT_A_BUG,
        external: true,
      },
    ],
  },
];

export default navigation;
